import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatDialogClose } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

import { UserService } from '@modules/shared/services/user.service';

import { BaseModalComponent } from '../../base-modal/base-modal.component';

@Component({
  selector: 'mb-first-favorite-modal',
  templateUrl: './first-favorite-modal.component.html',
  styleUrls: ['./first-favorite-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BaseModalComponent, MatDialogClose, TranslatePipe],
})
export class FirstFavoriteModalComponent {
  private userService = inject(UserService);

  signUp() {
    this.userService.login();
  }
}
